import { render, staticRenderFns } from "./VIPcenter.vue?vue&type=template&id=a75e4996&scoped=true&"
import script from "./VIPcenter.vue?vue&type=script&lang=js&"
export * from "./VIPcenter.vue?vue&type=script&lang=js&"
import style0 from "./VIPcenter.vue?vue&type=style&index=0&id=a75e4996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75e4996",
  null
  
)

export default component.exports